import { TmsGraphService } from '@/core/services/tms-graph.service'
import {
    DownloadReportAutoGraphParams,
    DownloadReportAutoGraphResponse,
    GetPreTripDetailsResponse,
    GetPreTripsParams,
    GetPreTripsResponse,
    PreTripUpdateCommentPayload,
    UpdatePreTripPayload,
} from '@/core/types/tms-graph.types'

const tmsGraphService = new TmsGraphService()

class TmsGraphRealisation {
    getPreTrips(params: GetPreTripsParams): Promise<GetPreTripsResponse> {
        return tmsGraphService.getPreTrips(params)
    }

    getPreTripDetails(id: number): Promise<GetPreTripDetailsResponse> {
        return tmsGraphService.getPreTripDetails(id)
    }

    updatePreTrip(id: number, payload: UpdatePreTripPayload): Promise<void> {
        return tmsGraphService.updatePreTrip(id, payload)
    }

    createScheduleExcel(payload: FormData): Promise<void> {
        return tmsGraphService.createScheduleExcel(payload)
    }

    downloadReportAutoGraph(
        params: DownloadReportAutoGraphParams
    ): Promise<DownloadReportAutoGraphResponse> {
        return tmsGraphService.downloadReportAutoGraph(params)
    }

    getPretripsForCompleteDay(): Promise<any> {
        return tmsGraphService.getPretripsForCompleteDay()
    }

    updateComment(id: number, payload: PreTripUpdateCommentPayload): Promise<void> {
        return tmsGraphService.updateComment(id, payload)
    }
}

export const tmsGraph = new TmsGraphRealisation()
